import { render, staticRenderFns } from "./ForumGuide.vue?vue&type=template&id=40540062&scoped=true"
import script from "./ForumGuide.vue?vue&type=script&lang=js"
export * from "./ForumGuide.vue?vue&type=script&lang=js"
import style0 from "./ForumGuide.vue?vue&type=style&index=0&id=40540062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40540062",
  null
  
)

export default component.exports